import { RegresosDeAlumna } from "../../../../components/horarios/regresoClases";
import React,
{
    useEffect,
    useRef,
    useState
} from "react";

import {
    useNavigate,
    useSearchParams
} from "react-router-dom";

import {
    useDispatch,
    useSelector
} from "react-redux";

import Constants,
{
    ENROLLMENT_STATUS,
    FINANCES_MODALS,
    invoiceStatus,
    owedArticleStatus,
    owedTuitionStatus,
    PERMISSIONS_CODES,
    ROLE,
    TRANSFER_MODAL_CONTENT,
    TUITION_PROGRESS_STATUS
} from "../../../../constants";

import {
    RootState,
    enableIdleLockSwitch,
    disableIdleLockSwitch,
    displayNotice,
    setCurrentUserCampus,
    setCurrentUserCampusId,
    AppDispatch
} from "../../../../globals";

import {
    getErrorMessage,
    plataformasActivas
} from "../../../../common";

import HttpManager from "../../../../services/HttpManager";

import {
    handleArticlesSelection,
    handleTuitionsSelection,
    setCheckedArticles,
    setDisabledTuitions,
    setGeneralData,
    setIsCancelPayment,
    setIsNewInvoice,
    setIsPartialPayment,
    setModalContent,
    setRefundItems,
    setSelectedArticles,
    setSelectedCourses,
    setSelectedCredit,
    setSelectedInvoice,
    setSelectedPayment,
    setSelectedTuitions,
    setShowModal,
    setShowTransferCreditModal,
    setStudentData,
    setTotalCheckoutItems,
    setTotalToPaid,
    setTransferModalContent
} from "../../../../redux/reducers/accountStatementReducer";
import { setPermissions, setCurrentCampus, setCurrentCampusId, UserState } from "../../../../redux/reducers/sessionReducer";
import { setPaymentMethods } from "../../../../redux/reducers/catalogReducer";
import { handleSelectedPayment } from "../../../../redux/reducers/paymentsReducer";

import CustomIcon from "../../../../components/customIcon";
import { Column } from "../../../../components/commonTable";
import ButtonComponent from "../../../../components/buttons/button";
import AccountStatementView from "./accountStatementView";

import "./helper.css";
import { handleSelectedInvoice } from "../../../../redux/reducers/invoicesReducer";
import { ArticleDTO } from "../../../../models/ArticleDTO";
import { TuitionDTO } from "../../../../models/TuitionDTO";
import { dinero, recargoDetalle } from "../../../../utils/recargo";
import { StudentDTO } from "../../../../models/StudentDTO";
import { handleSelectedCredit } from "../../../../redux/reducers/creditsReducer";
import KitHistoryModal from "../../../../components/kits/kitHistoryModal";
import { kitDeliveryStatus, kitDeliveryStatusLabels } from "../../../../constants";

const AccountStatementController = (props: any, route: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const http = HttpManager.getInstance();
    const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value);
    const permissions: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.permissions);
    const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
    const currentRole: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole);
    /*
        El plantel del estado de cuenta es el que muestra la barra de arriba.

        WAPP lleva DOS "plantel actual": el de la barra (currentUserCampusId, que
        es el que la persona ve y cambia) y el de sessionState, que se guarda en
        el navegador y se restaura al entrar. Los dos se fijan desde fuentes
        distintas al iniciar sesion, asi que se separan solo: la barra decia
        "San Pedro Sula" y esta pantalla consultaba Torreon.

        Consecuencia real (2026-09-19): el estado de cuenta de una alumna de SPS
        con 24,000.00 de saldo salia en 0.00 y en pesos, porque preguntaba por
        ella en otro plantel, donde no tiene nada, y tomaba de ahi la moneda.

        Se busca el plantel de la barra dentro del MISMO catalogo del que salia
        antes, para conservar la forma del objeto (countryId, currencyId...). Si
        por lo que sea no esta, se usa el de antes y nada cambia.

        Desde el 19-sep app.tsx ya mantiene los dos sincronizados para toda la
        aplicacion, asi que esto es cinturon y tirantes. Se deja porque aqui el
        desfase de un instante no es inofensivo: abrir un enlace con el plantel
        viejo saca el aviso "El alumno del enlace no esta en este plantel".
    */
    const campusDeLaSesion: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
    const plantelDeLaBarra: number | null = useSelector((state: RootState) => state.currentUserCampusId.value);
    const catalogoDePlanteles: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
    const currentCampus: any = (
        plantelDeLaBarra == null ? null : catalogoDePlanteles?.find((plantel: any) => plantel.id === plantelDeLaBarra)
    ) ?? campusDeLaSesion;
    const studentData: StudentDTO = useSelector((state: RootState) => state.rootReducer.accountStatement.studentData);
    const checkedArticles: any = useSelector((state: RootState) => state.rootReducer.accountStatement.checkedArticles);
    const selectedCourses: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedCourses);
    const selectedArticles: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedArticles);
    const selectedTuitions: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedTuitions);
    const disabledTuitions: any = useSelector((state: RootState) => state.rootReducer.accountStatement.disabledTuitions);
    const selectedInvoice: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedInvoice);
    const selectedPayment: any = useSelector((state: RootState) => state.rootReducer.accountStatement.selectedPayment);
    const isPartialPayment: boolean = useSelector((state: RootState) => state.rootReducer.accountStatement.isPartialPayment);
    const isNewInvoice: boolean = useSelector((state: RootState) => state.rootReducer.accountStatement.isNewInvoice);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    // Kits overhaul (Sep 2026): read-only bitácora of a kit, opened from the kits table.
    const [historyKit, setHistoryKit] = useState<ArticleDTO | null>(null);
    //Enlace directo al estado de cuenta: /statement?alumno=<id>&plantel=<id> (Esteban, 2026-09-11).
    const [searchParams, setSearchParams] = useSearchParams();
    const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
    const enlaceAtendido = useRef<string | null>(null);
    const [checkoutData, setCheckoutData] = useState<any>({
        courses: [],
        articles: []
    });

    const tuitionColumns: Column[] = [
        {
            id: "selectTuition",
            header: "",
            accessor: "",
            render: (data: TuitionDTO) => (data.statusId === 2 || !data.isDebt) ? <></>
                : <button className="btn btn-default" type="button"
                    disabled={idleLocked}
                >
                    <CustomIcon name="bCheck" />
                </button>,
            overrideCellStyle: () => ({
                borderBottom: 0
            })
        },
        {
            id: "monthNumber",
            header: Constants.Common.concept,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "monthNumber",
            // Recargo automático (Etapa 2): dentro del renglón de su mensualidad, no como un mes más.
            // Tras un cambio de horario, los meses que se quedaron en el anterior dicen de qué horario son.
            // Actualizaciones v2 (2026-10-29): de dónde viene el dinero del mes (cambio de curso, reparto, mes eximido) y a dónde se fue.
            render: (data: TuitionDTO) => data.surcharge || data.previousSchedule || data.moneyIn?.length || data.moneyOut?.length || data.exemptionReason ? (
                <div>
                    {data.monthNumber}
                    {data.previousSchedule ? <div style={{ fontSize: 13, color: "var(--wa-apagado)", fontWeight: 500 }}>Horario anterior: {data.previousSchedule}</div> : null}
                    {data.exemptionReason ? <div style={{ fontSize: 13, color: "var(--wa-apagado)", fontWeight: 600 }}>Eximido: {data.exemptionReason}</div> : null}
                    {(data.moneyIn || []).map((o, i) => (
                        <div key={"in" + i} style={{ fontSize: 13, color: "var(--wa-apagado)", fontWeight: 500 }}>
                            {o.text} ({dinero(o.amount, data.currencyCode)}{o.invoice ? ", Factura " + o.invoice : ""})
                        </div>
                    ))}
                    {(data.moneyOut || []).map((o, i) => (
                        <div key={"out" + i} style={{ fontSize: 13, color: "var(--wa-apagado)", fontWeight: 500 }}>{o.text} ({dinero(o.amount, data.currencyCode)})</div>
                    ))}
                    {data.surcharge ? 
                    <div style={{ fontSize: 13, color: data.surcharge.pending > 0.009 ? "var(--wa-oro)" : "var(--wa-apagado)", fontWeight: 600 }}>
                        + recargo{data.surcharge.days ? " · " + data.surcharge.days + (data.surcharge.days === 1 ? " día tarde" : " días tarde") : ""}
                        {recargoDetalle(data.surcharge, data.currencyCode) ? <span style={{ fontWeight: 500, color: "var(--wa-apagado)" }}> · {recargoDetalle(data.surcharge, data.currencyCode)}</span> : null}
                    </div> : null}
                </div>
            ) : data.monthNumber
        },
        {
            id: "dueDate",
            header: Constants.Common.endDate,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "dueDate"
        },
        {
            id: "billingStatus",
            header: Constants.Common.billingStatus,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "",
            render: (data: TuitionDTO) => <span
                style={{
                    color: data.isExpired && (
                        (
                            data.isDebt && (data.statusId === owedTuitionStatus.PENDING
                            || data.statusId === owedTuitionStatus.PARTLY_PAID)
                        ) &&
                        (
                            data.enrollmentStatusId != ENROLLMENT_STATUS.ERROR
                            && data.enrollmentStatusId != ENROLLMENT_STATUS.NOT_STARTED
                        )
                    )
                        ? Constants.Styles.text.colors.red
                        : Constants.Styles.text.colors.blackPrimary,
                    font: Constants.Styles.text.fonts.robotoBold16,
                    marginBottom: 0
                }}>
                {
                    data.isExpired && (
                        (
                            data.isDebt && (data.statusId === owedTuitionStatus.PENDING
                            || data.statusId === owedTuitionStatus.PARTLY_PAID)
                        ) &&
                        (
                            data.enrollmentStatusId != ENROLLMENT_STATUS.ERROR
                            && data.enrollmentStatusId != ENROLLMENT_STATUS.NOT_STARTED
                        )
                    ) ? `Vencida/${data.status}` : data.status
                }
            </span>
        },
        {
            id: "progressStatus",
            header: Constants.Common.progressStatus,
            overrideHeaderStyle: () => ({ textAlign: "center" }),
            accessor: "",
            render: (data: TuitionDTO) => <span
                style={{
                    marginBottom: 0,
                    font: Constants.Styles.text.fonts.robotoBold16,
                    color: data.progressStatusId === TUITION_PROGRESS_STATUS.NO_COMPLETED
                        ? Constants.Styles.text.colors.red
                        : Constants.Styles.text.colors.blackPrimary,
                }
                }>
                {data.progressStatus}
            </span>,
            overrideCellStyle: () => ({
                textAlign: "center"
            })
        },
        {
            id: "totalAmount",
            header: Constants.Common.totalAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: TuitionDTO) => data.surcharge
                ? <div>{data.subTotal.moneyFormat}<div style={{ fontSize: 13, color: "var(--wa-oro)", fontWeight: 600 }}>+ {dinero(data.surcharge.state === "eximido" ? 0 : data.surcharge.subTotal, data.currencyCode)}</div></div>
                : data.subTotal.moneyFormat,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "paidAmount",
            header: Constants.Common.paidAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: TuitionDTO) => data.surcharge && data.surcharge.paid > 0.009
                ? <div>{data.paidAmount.moneyFormat}<div style={{ fontSize: 13 }}>+ {dinero(data.surcharge.paid, data.currencyCode)}</div></div>
                : data.paidAmount.moneyFormat,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "pendingAmount",
            header: Constants.Common.pendingAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: TuitionDTO) => data.surcharge && data.surcharge.pending > 0.009
                ? <div>{data.pendingAmount.moneyFormat}<div style={{ fontSize: 13, color: "var(--wa-oro)", fontWeight: 600 }}>+ {dinero(data.surcharge.pending, data.currencyCode)}</div></div>
                : data.pendingAmount.moneyFormat,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "invoice",
            header: Constants.Common.invoice,
            //En telefono la factura va arriba, junto al concepto. (Esteban, 2026-09-20)
            enCabeceraEnTelefono: true,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: TuitionDTO) => data.invoiceId > 0
                ? <ButtonComponent className="wa-btn sm link"
                    tooltip={Constants.Common.invoiceDetail}
                    style={{ opacity: idleLocked ? 0.5 : 1 }}
                    disabled={idleLocked}
                    onClick={() => getInvoiceById(data.invoiceId)}
                >
                    {data.invoiceId.toString()}
                </ButtonComponent>
                : "-",
            renderSubRow: (data: TuitionDTO) => {
                // La mensualidad ya está pagada pero su recargo no: el carrito no lo toma solo; va por Registrar pago.
                if (data.surcharge && data.surcharge.pending > 0.009 && (data.statusId === owedTuitionStatus.FULLY_PAID || data.invoiceId > 0)) {
                    return <div style={{ color: "var(--wa-oro)", textAlign: "center", fontWeight: 600 }}>
                        Recargo pendiente de {dinero(data.surcharge.pending, data.currencyCode)}: se cobra con «Registrar Pago».
                    </div>;
                }
                return data.invoiceId === 0
                    && data.statusId !== invoiceStatus.FULLY_PAID
                    && !data.canBePaid
                    && (data.enrollmentStatusId != ENROLLMENT_STATUS.ERROR
                        && data.enrollmentStatusId != ENROLLMENT_STATUS.NOT_STARTED)
                    ? (
                        <div style={{
                            color: Constants.Styles.text.colors.red,
                            textAlign: "center"
                        }}>
                            {data.cannotBePaidReason}
                        </div>
                    ) : null;
            },
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        }
    ];

    const articleColumns: Column[] = [
        {
            id: "selectArticle",
            header: "",
            accessor: "",
            render: (data: ArticleDTO) => (data.statusId === owedArticleStatus.FULLY_PAID || data.isCancelled) ? <></>
                : <button className="btn btn-default" type="button"
                    disabled={false}
                >
                    <CustomIcon name="bCheck" />
                </button>,
            overrideCellStyle: () => ({
                borderBottom: 0
            })
        },
        {
            id: "name",
            header: Constants.Common.concept,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "name"
        },
        {
            id: "group",
            header: "Tipo",
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "",
            render: (data: ArticleDTO) => <span style={{ color: "var(--wa-apagado)", whiteSpace: "nowrap" }}>{data.group}</span>
        },
        {
            id: "createdAt",
            header: Constants.Common.date,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "createdAt"
        },
        {
            id: "status",
            header: Constants.Common.status,
            overrideHeaderStyle: () => ({ textAlign: "left" }),
            accessor: "",
            render: (data: ArticleDTO) => <span
                style={{
                    color: data.isCancelled ? "var(--wa-apagado)" : Constants.Styles.text.colors.blackPrimary,
                    font: Constants.Styles.text.fonts.robotoBold16,
                    marginBottom: 0
                }}>
                {data.status}
                {
                    data.isCancelled
                        ? <><br /><small style={{ color: "var(--wa-apagado)", fontWeight: 400 }}>{[data.cancelReason, data.cancelledAt].filter(Boolean).join(" · ")}</small></>
                        : (data.statusId === owedArticleStatus.PENDING && !data.isDebt
                            ? <><br /><small style={{ color: "var(--wa-apagado)", fontWeight: 400 }}>Por pagar</small></>
                            : null)
                }
            </span>
        },
        {
            id: "totalAmount",
            header: Constants.Common.totalAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: ArticleDTO) => data.subTotal.moneyFormat,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "paidAmount",
            header: Constants.Common.paidAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: ArticleDTO) => data.paidAmount.moneyFormat,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "pendingAmount",
            header: Constants.Common.pendingAmount,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: ArticleDTO) => data.isDebt
                ? data.pendingAmount.moneyFormat
                : <span style={{ color: "var(--wa-tenue)" }}>—</span>,
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        },
        {
            id: "delivery",
            header: "Entrega",
            accessor: "",
            render: (data: ArticleDTO) => data.isCancelled ? <span style={{ color: "#AAA" }}>—</span> : <span style={{
                color: data.deliveryStatusId === kitDeliveryStatus.DELIVERED ? "#1E7E34"
                    : data.deliveryStatusId === kitDeliveryStatus.PARTIAL ? "#B8860B"
                    : data.deliveryStatusId === kitDeliveryStatus.PENDING ? Constants.Styles.text.colors.red : "#888",
                fontWeight: 600, whiteSpace: "nowrap"
            }}>
                {kitDeliveryStatusLabels[data.deliveryStatusId] || data.deliveryStatus}
                {data.deliveredAt ? <><br /><small style={{ color: "#888", fontWeight: 400 }}>{data.deliveredAt}</small></> : null}
            </span>,
            overrideCellStyle: () => ({
                textAlign: "center"
            })
        },
        {
            id: "history",
            header: "Historial",
            accessor: "",
            render: (data: ArticleDTO) => <ButtonComponent
                className="wa-btn sm link"
                style={{ opacity: idleLocked ? 0.5 : 1 }}
                tooltip="Ver historial del kit"
                disabled={idleLocked}
                onClick={() => setHistoryKit(data)}
            >
                Ver
            </ButtonComponent>,
            overrideCellStyle: () => ({
                textAlign: "center"
            })
        },
        {
            id: "invoice",
            header: Constants.Common.invoice,
            //En telefono la factura va arriba, junto al concepto. (Esteban, 2026-09-20)
            enCabeceraEnTelefono: true,
            overrideHeaderStyle: () => ({ textAlign: "right" }),
            accessor: "",
            render: (data: ArticleDTO) => data.invoiceId > 0
                ?
                <ButtonComponent
                    className="wa-btn sm link"
                    style={{ opacity: idleLocked ? 0.5 : 1 }}
                    tooltip={Constants.Common.invoiceDetail}
                    disabled={idleLocked}
                    onClick={() => getInvoiceById(data.invoiceId)}
                >
                    {data.invoiceId.toString()}
                </ButtonComponent>
                : "-",
            overrideCellStyle: () => ({
                textAlign: "right"
            })
        }
    ];

    const resetStateData = () => {
        dispatch(setSelectedCourses([]));
        dispatch(setSelectedTuitions(new Set()));
        dispatch(setDisabledTuitions(new Set()));
        dispatch(setCheckedArticles(new Set()));
        dispatch(setSelectedArticles([]));
        dispatch(setRefundItems(new Set()));
        dispatch(setIsPartialPayment(false));
        setSelectedInvoice(null);
    }

    const onError = (message: string) => {
        dispatch(displayNotice({
            cornerClose: false,
            message: message,
            heading: <h3 style={{
                color: "var(--wa-rojo-error)",
                display: "inline-block"
            }}>
                Error
            </h3>
        }));
    }

    const toggleArticleSelection = (article: any) => {
        dispatch(handleArticlesSelection(article));
    }

    const toggleTuitionsSelection = (tuition: any) => {
        dispatch(handleTuitionsSelection(tuition));
    }

    const tuitionColumnsWithLogic = tuitionColumns.map((column: Column) => {
        if (column.id === "selectTuition" && column.render) {
            return {
                ...column,
                render: permissions.includes(PERMISSIONS_CODES.PAYMENT_PERMISSIONS.CREATE)
                    && permissions.includes(PERMISSIONS_CODES.INVOICE_PERMISSIONS.CREATE
                        || currentRole.code === ROLE.SUPER_ADMIN
                    )
                    ? (tuition: TuitionDTO) => (
                        tuition.statusId === owedTuitionStatus.PENDING
                            && tuition.invoiceId === 0
                            ? <button
                                className="btn btn-default"
                                type="button"
                                disabled={idleLocked
                                    || !tuition.canBePaid
                                    || Array.from(disabledTuitions).includes(tuition.id)}
                                onClick={() => toggleTuitionsSelection(tuition)}
                            >
                                <CustomIcon
                                    name={Array.from(selectedTuitions).includes(tuition.id) ? "bCheck" : "bUncheck"}
                                />
                            </button>
                            // 1-nov (Veronica, Barbería MTY): un mes abonado con saldo y factura no tenía cómo cobrarse desde aquí; abre Registrar Pago.
                            : tuition.isDebt && tuition.invoiceId > 0 && (Number((tuition as any).pendingAmount?.value) || 0) > 0.009
                                && (tuition.statusId === owedTuitionStatus.PARTLY_PAID || tuition.statusId === owedTuitionStatus.PENDING || tuition.statusId === owedTuitionStatus.OVERDUE)
                                ? <button type="button" className="btn btn-link btn-sm" style={{ padding: 0, whiteSpace: "nowrap" }} disabled={idleLocked}
                                    title="Lo que falta se cobra con Registrar Pago" onClick={() => setShowMulti(true)}>Cobrar</button>
                                : <React.Fragment />
                    )
                    : () => <React.Fragment />,
            };
        }
        return column;
    });

    const articleColumnsWithLogic = articleColumns.map((column: Column) => {
        if (column.id === "selectArticle" && column.render) {
            return {
                ...column,
                render: (article: ArticleDTO) => (
                    permissions.includes(PERMISSIONS_CODES.PAYMENT_PERMISSIONS.CREATE)
                    && permissions.includes(PERMISSIONS_CODES.INVOICE_PERMISSIONS.CREATE
                        || currentRole.code === ROLE.SUPER_ADMIN
                    )
                    ? (
                    article.statusId === owedArticleStatus.PENDING && article.invoiceId === 0
                        ? <button
                            className="btn btn-default"
                            type="button"
                            disabled={idleLocked}
                            onClick={() => toggleArticleSelection(article)}
                        >
                            <CustomIcon name={Array.from(checkedArticles).includes(article.id) ? "bCheck" : "bUncheck"} />
                        </button>
                        : <></>
                    )
                    : () => <></>
                ),
            };
        }
        return column;
    });

    const getStudentById = async () => {
        try {
            let response = await http.studentService.getStudentById(
                currentCampus.id,
                studentData.id
            );
            let student = response.data;
            return student;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
        }
    }

    const getStudentCourses = async () => {
        try {
            let response = await http.financesService.getStudentCourses(
                currentCampus.id,
                studentData.id
            );
            let courses = response.data;
            return courses;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
            return [];
        }
    }

    const getStudentArticles = async () => {
        try {
            let response = await http.financesService.getStudentArticles(
                currentCampus.id,
                studentData.id
            );
            let articles = response.data;
            return articles;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
            return [];
        }
    }

    const getPaymentMethods = async () => {
        try {
            const response = await http.paymentMethodService
                .getPaymentMethodsByCountry(currentCampus.countryId);
            const paymentMethos = response.data;
            return paymentMethos;
        } catch (err: any) {
            console.error(err);
        }
    }

    const fetchData = async () => {
        resetStateData();
        const messageError: string = "No se pudo extraer la información financiera del alumno seleccionado"
        dispatch(enableIdleLockSwitch())
        if (currentCampus && userData) {
            try {
                const [
                    student,
                    courses,
                    articles,
                    paymentMethods
                ] = await Promise.all([
                    getStudentById(),
                    getStudentCourses(),
                    getStudentArticles(),
                    getPaymentMethods()
                ]);
                const coursesHistory = courses
                    .filter((course: any) => course.enrollmentStatusId !== ENROLLMENT_STATUS.ACTIVE);
                const activeCourses = courses
                    .filter((course: any) => course.enrollmentStatusId === ENROLLMENT_STATUS.ACTIVE);
                // Anulados (Sep 2026) viven en el bloque de historial, nunca en el saldo activo.
                const articlesHistory = articles
                    .filter((article: any) => article.statusId === owedArticleStatus.DELIVERED || article.isCancelled);
                const activeArticles = articles
                    .filter((article: any) => article.statusId !== owedArticleStatus.DELIVERED && !article.isCancelled)
                dispatch(setGeneralData({
                    student,
                    courses: activeCourses,
                    articles: activeArticles,
                    coursesHistory,
                    articlesHistory,
                    balance: student?.generalBalance,
                }));
                dispatch(disableIdleLockSwitch());
                dispatch(setPaymentMethods(paymentMethods));
                setIsLoaded(true);
            }
            catch (error: any) {
                dispatch(disableIdleLockSwitch());
                if (error.status === 404) {
                    navigate("/students");
                }
                else {
                    console.log(error);
                    onError(messageError);
                }
            }
        }
    }

    const getInvoiceById = async (invoiceId: number) => {
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedInvoice({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                studentId: studentData.id,
                invoiceId
            })).unwrap();
            let invoice = response.data;
            dispatch(setSelectedInvoice(invoice));
            dispatch(setTotalToPaid(invoice.pendingAmount));
            dispatch(setIsNewInvoice(false));
            dispatch(disableIdleLockSwitch());
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showPaymentDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            const response = await dispatch(handleSelectedPayment({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                paymentId: rowData.id
            })).unwrap();
            dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));

            const payment = {
                ...response.data,
                account: response.data.recipientAccount,
                amount: response.data.amount.value,
                files: response.data.documents
            };
            dispatch(setSelectedPayment(payment));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showCreditDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedCredit({
                campusId: currentCampus.id,
                creditId: rowData.id
            })).unwrap();
            const credit = response.data;
            dispatch(setSelectedCredit(credit));
            dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT_DETAILS));
            dispatch(setShowModal(true));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showSuccessMessage = () => {
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

    const cancelInvoice = () => {
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_INVOICE));
    }

    const proccessPayment = () => {
        dispatch(setIsPartialPayment(true));
        dispatch(setIsNewInvoice(false));
        dispatch(setModalContent(FINANCES_MODALS.EMIT_PAYMENT));
    }

    const closeModalInvoiceDetail = () => {
        dispatch(setIsPartialPayment(false));
        dispatch(setShowModal(false));
        dispatch(setSelectedInvoice(null));
    }

    const handleCancelPayment = () => {
        setIsCancelPayment(true);
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_PAYMENT))
    }

    const paymentDetailCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE))
    }

    const showPaymentUpdateModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.UPDATE_PAYMENT));
    }

    const updatePaymentCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE))
    }

    const onSuccessUpdatePayment = () => {
        dispatch(setModalContent(FINANCES_MODALS.UPDATE_PAYMENT));
        showSuccessMessage();
        showPaymentDetail(selectedPayment);
    }

    const cancelPaymentCloseModal = () => {
        setIsCancelPayment(false);
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
    }

    const onSuccessCancelPayment = () => {
        fetchData();
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
        showSuccessMessage();
    }

    const closeModalEmitPayment = () => {
        dispatch(setShowModal(false));
    }

    const cancelEmitPayment = () => {
        if (isPartialPayment && !isNewInvoice) {
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        } else {
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        }
    }

    const showApplyCreditModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT));
    }

    const cancelInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE));
    }

    const onSuccessCancelInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const goToProccessPayment = (isPartialPayment: boolean = false) => {
        dispatch(setIsPartialPayment(isPartialPayment));
        dispatch(setIsNewInvoice(true));
        dispatch(setModalContent(FINANCES_MODALS.EMIT_PAYMENT));
    }

    const closeModalCheckout = () => {
        dispatch(setShowModal(false));
    }

    const generateInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
    }

    const onSuccessGeneratePaidInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const onSuccessEmitPayment = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    // Pago multipersona desde el estado de cuenta: este alumno ya viene como primera persona.
    const [showMulti, setShowMulti] = useState<boolean>(false);
    const [receiptDetailId, setReceiptDetailId] = useState<number | null>(null);

    const showCheckoutModal = () => {
        dispatch(setShowModal(true));
        dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
    }

    const onSuccessApplyCredit = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const cancelApplyCredit = () => {
        if (isPartialPayment && !isNewInvoice) {
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        } else {
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        }
    }

    const closeModalCancelApplyCredit = () => {
        dispatch(setShowModal(false));
    }

    const creditDetailCloseModal = () => {
        dispatch(setShowModal(false));
    }

    const onSuccessTransferCreditModal = () => {
        fetchData();
        dispatch(setShowTransferCreditModal(false));
        showSuccessMessage();
    }

    const showTransferCreditModal = () => {
        dispatch(setTransferModalContent(TRANSFER_MODAL_CONTENT.SELECT_STUDENT))
        dispatch(setShowTransferCreditModal(true));
    }

    const closeTransferCreditModal = () => {
        dispatch(setShowTransferCreditModal(false));
    }

    //Alguien abrió /statement?alumno=<id>&plantel=<id>: se cambia de plantel si hace falta,
    //se trae al alumno y se abre su estado de cuenta (Esteban, 2026-09-11).
    const abrirAlumnoDelEnlace = async (alumnoId: number) => {
        dispatch(enableIdleLockSwitch());
        try {
            const respuesta = await http.studentService.getStudentById(currentCampus.id, alumnoId);
            const alumno: any = respuesta.data;
            dispatch(setStudentData({
                id: alumno.id,
                email: alumno.email,
                userId: alumno.id,
                firstName: alumno.firstName,
                lastName: alumno.lastName,
                identityCode: alumno.identityCode,
                identificationCode: alumno.correlative || alumno.identificationCode
            }));
        }
        catch (error: any) {
            dispatch(disableIdleLockSwitch());
            onError("El alumno del enlace no está en este plantel o no está disponible.");
        }
    }

    const cambiarPlantel = (campusId: number) => {
        localStorage.setItem("currentCampus", `C_${campusId}`);
        dispatch(setCurrentUserCampusId(campusId));
        dispatch(setCurrentUserCampus(`C_${campusId}`));
        dispatch(setCurrentCampusId(campusId));
        const plantel = campuses?.find((campus: any) => campus.id === campusId);
        if (plantel) {
            dispatch(setCurrentCampus(plantel));
        }
    }

    useEffect(() => {
        if (!userData || !userData.token) {
            return;
        }
        //undefined = el catálogo de planteles todavía no llega (app.tsx lo pide): se espera sin aviso (2026-10-21).
        if (currentCampus === undefined) {
            return;
        }
        if (currentCampus === null) {
            onError(
                "No hay planteles registrados o asignados al rol en uso por el usuario, " +
                "por lo que el acceso a este módulo permanecerá deshabilitado."
            )
            return;
        }

        const alumnoEnlazado: string | null = searchParams.get("alumno");
        const plantelEnlazado: number = +(searchParams.get("plantel") || 0);

        if (alumnoEnlazado != null && enlaceAtendido.current !== alumnoEnlazado) {
            if (plantelEnlazado > 0 && currentCampus.id !== plantelEnlazado) {
                cambiarPlantel(plantelEnlazado);
                return;
            }
            enlaceAtendido.current = alumnoEnlazado;
            abrirAlumnoDelEnlace(+alumnoEnlazado);
            return;
        }

        if (studentData && studentData.id) {
            //La dirección lleva al alumno, para poder compartir el enlace de su estado de cuenta.
            if (searchParams.get("alumno") !== String(studentData.id)) {
                const parametros = new URLSearchParams(searchParams);
                parametros.set("alumno", String(studentData.id));
                parametros.set("plantel", String(currentCampus.id));
                enlaceAtendido.current = String(studentData.id);
                setSearchParams(parametros, { replace: true });
            }
            fetchData();
        }
    }, [userData, currentCampus, studentData, searchParams]);

    useEffect(() => {
        if (isLoaded) {
            fetchData();
        }
    }, [isLoaded]);

    useEffect(() => {
        setCheckoutData({
            courses: selectedCourses,
            articles: selectedArticles
        });
        if (selectedCourses.length > 0 || selectedArticles.length > 0) {
            dispatch(setShowModal(true));
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        } else {
            dispatch(setShowModal(false));
        }
        dispatch(setTotalCheckoutItems(selectedTuitions.size + selectedArticles.length));
    }, [selectedCourses, checkedArticles]);

    useEffect(() => {
        if (selectedInvoice && Object.keys(selectedInvoice).length > 0) {
            dispatch(setShowModal(true));
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        }
    }, [selectedInvoice]);

    return !isLoaded || currentCampus == null || userData === null
        ? <React.Fragment></React.Fragment>
        : <>{historyKit ? <KitHistoryModal campusId={currentCampus.id} kitId={historyKit.id}
            title={"Historial · " + (historyKit.title || historyKit.name)} subtitle={historyKit.name + (historyKit.createdBy ? " · cargado por " + historyKit.createdBy : "")}
            onClose={() => setHistoryKit(null)} /> : null}
        {/* Fase E: si tiene un regreso a clases programado (Pausado con fecha o Clases de Cortesía), se ve aquí */}
        {studentData?.id ? <RegresosDeAlumna campusId={currentCampus.id} studentId={studentData.id} /> : null}
        <AccountStatementView
            accountStatementProps={{
                showCheckoutModal,
                //Plataformas (FASE 4): acceso y regalo de mes, apagado mientras PLATAFORMAS_ACTIVAS sea false.
                plataformas: plataformasActivas(currentCampus) ? { campusId: currentCampus.id, reload: fetchData } : null,
                //Eximir meses (2026-10-28): el botón solo sale a Supervisión de Caja del plantel y superadmin (lo pregunta la vista).
                eximir: currentCampus && studentData ? { campusId: currentCampus.id, studentId: studentData.id, currencySymbol: currentCampus.currency || "", reload: fetchData } : null
            }}
            tableProps={{
                tuitionColumns: tuitionColumnsWithLogic,
                articleColumns: articleColumnsWithLogic
            }}
            checkoutDataProps={{
                checkoutData,
                goToProccessPayment,
                closeModal: closeModalCheckout
            }}
            invoiceDetailProps={{
                cancelInvoice,
                showPaymentDetail,
                showCreditDetail,
                proccessPayment,
                closeModal: closeModalInvoiceDetail
            }}
            emitPaymentProps={{
                isNewInvoice,
                isPartialPayment,
                closeModal: closeModalEmitPayment,
                cancelEmitPayment,
                showApplyCreditModal,
                onSuccess: onSuccessEmitPayment,
                // Una sola puerta para cobrar: Registrar Pago con este alumno puesto (cobrarEnRegistrar.tsx).
                openRegister: () => { dispatch(setShowModal(false)); setShowMulti(true); }
            }}
            paymentDetailProps={{
                onReceiptCancelled: () => fetchData(),
                handleCancelPayment,
                closeModal: paymentDetailCloseModal,
                showUpdatePayment: showPaymentUpdateModal
            }}
            paymentUpdateProps={{
                onSuccess: onSuccessUpdatePayment,
                closeModal: updatePaymentCloseModal
            }}
            cancelPaymentProps={{
                closeModal: cancelPaymentCloseModal,
                onSuccess: onSuccessCancelPayment
            }}
            cancelInvoiceProps={{
                closeModal: cancelInvoiceCloseModal,
                onSuccess: onSuccessCancelInvoice
            }}
            generateInvoiceProps={{
                onSuccess: onSuccessGeneratePaidInvoice,
                closeModal: generateInvoiceCloseModal
            }}
            applyCreditProps={{
                isNewInvoice,
                isPartialPayment,
                closeModal: closeModalCancelApplyCredit,
                cancelApplyCredit,
                onSuccess: onSuccessApplyCredit
            }}
            appliedCreditsDetailProps={{
                closeModal: creditDetailCloseModal,
            }}
            transferCreditProps={{
                showModal: showTransferCreditModal,
                onSuccess: onSuccessTransferCreditModal,
                closeModal: closeTransferCreditModal
            }}
            multiPaymentProps={{
                show: showMulti,
                open: () => setShowMulti(true),
                close: () => setShowMulti(false),
                onSuccess: (receipt: any) => { setShowMulti(false); fetchData(); setReceiptDetailId(Number(receipt.id)); },
                receiptId: receiptDetailId,
                closeReceipt: () => setReceiptDetailId(null),
                onReceiptCancelled: () => { setReceiptDetailId(null); fetchData(); },
                campusId: currentCampus?.id,
                countryId: currentCampus?.countryId,
                currencySymbol: currentCampus?.currency || ""
            }}
            cargarProductosProps={currentCampus ? {
                campusId: currentCampus.id,
                currencySymbol: currentCampus.currency || "",
                onDone: (total: number, piezas: number) => {
                    fetchData();
                    dispatch(displayNotice({
                        cornerClose: false,
                        message: (piezas === 1 ? "1 producto cargado" : piezas + " productos cargados") + " · " + (currentCampus.currency || "")
                            + total.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ". Ya está en Productos para cobrarlo.",
                        heading: <h3 style={{ color: "var(--wa-verde)", display: "inline-block" }}>Listo</h3>
                    }));
                }
            } : null}
        /></>
}

export default AccountStatementController;